import styled, { css } from "styled-components";
import Button from "./Button";

const PrimaryButton = styled(Button)`
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #fff;
    background-color: var(--main-color);
    border: 1px solid var(--main-dark-color);

    &:not(:disabled):hover {
        background-color: var(--main-dark-color);
        border-color: var(--main-dark-color);
    }
    &:disabled {
        border-color: var(--lightgray-color);
    }
`;

export default PrimaryButton